<template>
    <div ref="fullCalendar" class="timeline-wrapper">
        <FullCalendar :options="calendarOptions">
            <template v-slot:eventContent='arg'>
                <div class="text-clipper" style="text-align: end;" >
                    <span :class="arg.event.extendedProps.classes + ' timeline-event'">{{ arg.event.title }}</span>
                </div>
            </template>
        </FullCalendar>
    </div>
</template>

<script>

import FullCalendar from '@fullcalendar/vue';
import ResourceTimelineView from '@fullcalendar/resource-timeline';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

import {mapActions, mapGetters} from "vuex";

export default {
    name: "Timeline",
    components:{
        FullCalendar
    },
    props:{},
    data(){
        var self = this;
        return{
            colors:[
                '#012e46',
                '#153f59',
                '#365b77',
                '#577996',
                '#7498b6'
            ]
        }
    },
    methods:{
        ...mapActions('production_control', ['createCalendar']),
        getTimeForNowIndicator(){
            let date = this.subtractHours(2);
            return date.toTimeString().split(' ')[0]
        },
        subtractHours(numOfHours, date = new Date()) {
            date.setHours(date.getHours() - numOfHours);
            return date;
        },
        beautifyTimeline(){
            $('.fc-timeline-bg').each(function(){

                $(this).find(".fc-timeline-bg-harness.is-clone:has(.shift-event)").remove()

                $(this).find(".fc-timeline-bg-harness:has(.shift-event)").each(function(){
                    $(this).clone()
                        .addClass('is-clone')
                        .css({
                            display: 'initial',
                            visibility: 'visible'
                        }).appendTo($(this).parent())
                    $(this).css({display: 'none'})
                });
                
                $(this).find(".fc-timeline-bg-harness.is-clone:has(.no-shift-event)").css({
                    'z-index': 15
                })

            })
        },
    },
    mounted(){
        let self = this;

        self.$nextTick(function(){
            self.beautifyTimeline()
        })
        window.beautifyTimeline = self.beautifyTimeline
    },
    watch:{
        calendarEvents(newCalendarEvents){
            let self = this;
            self.$nextTick(function(){
                self.beautifyTimeline()
            })
        }
    },
    computed:{
        ...mapGetters(['productionLines']),
        ...mapGetters('production_control',['calendarEvents']),
        resources(){
            var self = this;
            return this.productionLines.map((pl, i) => ({
                id: pl.id,
                title: pl.code,
                eventColor: self.colors.length > i? self.colors[i]:'#7498b6',
            }))
        },
        resourcesBiggestWidth(){
            let biggestWidth = 0;
            this.resources.forEach(function(resource){
                biggestWidth = resource.title.length > biggestWidth? resource.title.length : biggestWidth;
            })
            return biggestWidth * 1.33; //
        },
        calendarOptions(){
            let self = this;
            return {
                height: 'auto',
                editable: false,
                nowIndicator: true,
                scrollTime: this.getTimeForNowIndicator(),
                plugins: [
                    ResourceTimelineView,
                    dayGridPlugin,
                ],
                headerToolbar:
                    {
                        start:'title',
                        left: 'today prev,next', //'promptResource today prev,next',
                        center: 'title',
                        right: 'resourceTimelineThreeDays,resourceTimelineWeekCs' //'resourceTimelineDay,resourceTimelineThreeDays,resourceTimelineWeek,dayGridMonth'
                    },
                initialView: 'resourceTimelineThreeDays',
                views: {
                    resourceTimelineThreeDays: {
                        type: 'resourceTimeline',
                        duration: {days: 3},
                        buttonText: '3 días',
                        slotDuration: '00:15:00',
                        slotLabelInterval: '01:30:00',
                        resourceAreaWidth: `${this.resourcesBiggestWidth}ch`,

                    },
                    resourceTimelineWeekCs: {
                        type: 'resourceTimeline',
                        duration: {days: 7},
                        buttonText: 'Semana',
                        slotDuration: '00:30:00',
                        slotLabelInterval: '02:30:00',
                        resourceAreaWidth: `${this.resourcesBiggestWidth}ch`
                    }
                },
                resourceAreaHeaderContent: 'Lineas',
                // TODO : CARGAR AUTOMATICAMENTE!!!!
                resources: this.resources,
                resourceOrder: 'title',
                eventDidMount: function(info) {
                    $('.tooltip').remove()
                    if(info.event.extendedProps.hasOwnProperty('description')){
                        $(info.el).tooltip({
                            title: info.event.extendedProps.description,
                            placement: 'top',
                            trigger: 'hover',
                            container: 'body',
                            html: true
                        })
                    }
                },
                datesSet: function(){
                    //TODO: No funcionaaa
                    self.$nextTick(function(){
                        self.beautifyTimeline()
                    })
                },
                events:this.calendarEvents,
                buttonText:{
                    today: 'Hoy'
                },
                locale: 'es'
            }
        }
    }
}
</script>